<template>
  <v-col cols="12">
    <v-dialog
      v-model="showEventCreationDialog"
      :persistent="true"
      max-width="350"
    >
      <v-card>
        <v-card-title class="pt-5 pb-0"> Tipo de Turno</v-card-title>
        <v-card-text class="pb-0">
          <v-select
            :items="tipoTurnos"
            placeholder="Tipo de Turno"
            v-model="selectedEvent.title"
          />
        </v-card-text>
        <v-card-actions class="px-5 pt-0 pb-5">
          <v-btn @click="cancelEventCreation()" outlined color="primary"
            >Cancelar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn @click="closeCreationDialog()" class="primary">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showDeleteDialog" max-width="300">
      <v-card class="text-center">
        <v-card-title class="justify-center pt-5 pb-4"
          >¿Desea Eliminar el Turno?</v-card-title
        >
        <v-card-actions class="justify-center px-7 pt-0 pb-5">
          <v-btn @click="showDeleteDialog = false">No</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="confirmDelete">Si</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12">
        <h1>{{ horario.nombre }}</h1>
        <p>{{ horario.descripcion }}</p>
      </v-col>
      <v-col class="text-end">
        <v-btn
          @click="toggleEdit"
          v-if="!horario.asignado && !editableEvents.drag"
          >Modificar</v-btn
        >
        <v-btn @click="guardarHorario" v-if="editableEvents.drag" class="ml-4"
          >Guardar</v-btn
        >
      </v-col>
    </v-row>

    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="12" md="2" class="mt-0 pt-0">
        <v-row class="mb-1 mt-0 pt-0">
          <v-col cols="4" class="text-end ma-0 pa-0">
            <div>Trabajo</div>
            <div class="mt-1">Descanso</div>
          </v-col>
          <v-col cols="4" class="text-center ma-0 pa-0">
            <div>
              <v-icon small>fas fa-briefcase</v-icon>
            </div>
            <div>
              <v-icon small class="mt-1">fas fa-utensils</v-icon>
            </div>
          </v-col>
          <v-col class="text-left ma-0 pa-0">
            <div>
              <v-chip x-small color="#c0e6f0" class="pa-1 px-2"></v-chip>
            </div>
            <div>
              <v-chip x-small color="#f5e6ca" class="pa-1 px-2 mt-1"></v-chip>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="2">
        <v-select
          v-model="timeStep"
          label="Salto de Tiempo Calendario"
          :items="timeSteps"
          dense
        >
          <template v-slot:selection="{ item }">
            {{ getTimeStep(item) }}
          </template>
          <template v-slot:item="{ item }">
            {{ getTimeStep(item) }}
          </template>
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <vue-cal
        class="vuecal--blue-theme"
        ref="vuecal"
        :events="events"
        active-view="week"
        :editable-events="editableEvents"
        :time-cell-height="60"
        :time-step="timeStep"
        :no-event-label="'Dia Libre'"
        :disable-views="['years', 'year', 'month', 'day']"
        :hide-title-bar="true"
        :selected-date="minDate"
        :hide-view-selector="true"
        locale="es"
        :snap-to-time="5"
        :on-event-create="onEventCreate"
        @event-drag-create="showEventCreationDialog = true"
        @event-duration-change="onEventResize"
        @event-drop="onEventDrop"
      >
        <template #no-event>
          {{ "Sin Asignar" }}
        </template>
        <template #weekday-heading="{ heading }">{{ heading.label }}</template>
        <template #event="{ event }">
          <v-tooltip color="primary" left v-if="horario.asignado">
            <template v-slot:activator="{ on, attrs }">
              <div
                class="event-content"
                v-on="on"
                v-bind="attrs"
                style="cursor: pointer"
              >
                <v-icon small>{{
                  event.title == "TRABAJO"
                    ? "fas fa-briefcase"
                    : "fas fa-utensils"
                }}</v-icon>
                <small>
                  {{
                    `${formatTimeTo24h(event.start)} -
              ${formatTimeTo24h(event.end)}`
                  }}</small
                >
                <v-btn
                  icon
                  x-small
                  @click.stop="prepareDelete(event)"
                  color="red"
                  v-if="editableEvents.delete"
                >
                  <v-icon small>fas fa-times</v-icon>
                </v-btn>
              </div>
            </template>
            <v-row class="px-2" style="color: white">
              <small class="mr-2">
                {{ event.title }}
              </small>
              <v-icon x-small class="mr-2" dark>{{
                event.title == "TRABAJO"
                  ? "fas fa-briefcase"
                  : "fas fa-utensils"
              }}</v-icon>
              <small>
                {{
                  `${formatTimeTo24h(event.start)} -
                ${formatTimeTo24h(event.end)}`
                }}</small
              >
            </v-row>
          </v-tooltip>
          <div
            v-else
            class="event-content"
            v-on="on"
            v-bind="attrs"
            style="cursor: pointer"
          >
            <v-icon small>{{
              event.title == "TRABAJO" ? "fas fa-briefcase" : "fas fa-utensils"
            }}</v-icon>
            <small>
              {{
                `${formatTimeTo24h(event.start)} -
              ${formatTimeTo24h(event.end)}`
              }}</small
            >
            <v-btn
              icon
              x-small
              @click.stop="prepareDelete(event)"
              color="red"
              v-if="editableEvents.delete"
            >
              <v-icon small>fas fa-times</v-icon>
            </v-btn>
          </div>
        </template>
      </vue-cal>
    </v-row>
  </v-col>
</template>

<script>
import axios from "axios";
import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

export default {
  name: "MiniHorarios",
  components: {
    VueCal,
  },
  data() {
    return {
      events: [],
      selectedEvent: {
        title: "TRABAJO",
      },
      timeStep: 30,
      timeSteps: [30, 60, 120, 180, 240],
      tipoTurnos: ["TRABAJO", "DESCANSO"],
      horario: {},
      editableEvents: {
        title: false,
        drag: true,
        resize: true,
        delete: true,
        create: true,
      },
      isEditing: true,
      showEventCreationDialog: false,
      showDeleteDialog: false,
      deleteEventFunction: null,
      eventToDelete: null,
    };
  },
  computed: {
    minDate() {
      return new Date(2025, 6, 14);
    },
  },
  created() {
    const horarioId = this.$route.params.id;
    this.getDetallesHorario(horarioId);
  },
  methods: {
    getTimeStep(step) {
      const time = step / 60;

      if (time < 1) {
        return "30 minutos";
      } else if (time == 1) {
        return `${time} hora`;
      } else {
        return `${time} horas`;
      }
    },
    toggleEdit() {
      this.editableEvents.drag = !this.editableEvents.drag;
      this.editableEvents.delete = !this.editableEvents.delete;
      this.editableEvents.resize = !this.editableEvents.resize;
      this.editableEvents.create = !this.editableEvents.create;
    },
    getDetallesHorario(horarioId) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(`api/Marcaciones/DetalleHorarios/${horarioId}`, configuracion)
        .then((res) => {
          this.horario = res.data;
          this.events = this.horario.detalleHorario.map((dh) => {
            return {
              id: dh.detalleHorarioId,
              start: this.getDiaSemana(dh.diaSemana, dh.horaInicio),
              end: this.getDiaSemana(dh.diaSemana, dh.horaFin),
              title: dh.tipoDetalleHorario.nombre,
              class: dh.tipoDetalleHorario.nombre.toLowerCase(),
            };
          });

          if (this.horario.asignado) {
            this.toggleEdit();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getDiaSemana(diaSemanaId, time) {
      if (!time || typeof time !== "string") return null;

      const [hour, min] = time.split(":").map(Number);
      if (isNaN(hour) || isNaN(min)) return null;

      const date = new Date(2025, 6, 14 + (diaSemanaId - 1), hour, min, 0);

      return date;
    },
    onEventDrop({ event }) {
      const index = this.events.findIndex((e) => e.id === event.id);
      if (index > -1) {
        this.events.splice(index, 1, { ...event });
      }
    },
    guardarHorario() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      const formatearFechaLocal = (fecha) => {
        const pad = (n) => n.toString().padStart(2, "0");
        return `${fecha.getFullYear()}-${pad(fecha.getMonth() + 1)}-${pad(
          fecha.getDate()
        )}T${pad(fecha.getHours())}:${pad(fecha.getMinutes())}:${pad(
          fecha.getSeconds()
        )}`;
      };

      const formattedEvents = this.events.map((e) => ({
        ...e,
        id: typeof e.id == "number" ? e.id : 0,
        start: formatearFechaLocal(new Date(e.start)),
        end: formatearFechaLocal(new Date(e.end)),
      }));

      axios
        .post(
          `api/Marcaciones/DetalleHorarios/${this.horario.horarioId}/Detalle`,
          formattedEvents,
          configuracion
        )
        .then((res) => {
          this.getDetallesHorario();

          this.toggleEdit();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    formatTimeTo24h(dateTimeString) {
      const date = new Date(dateTimeString);
      const hora24 = date.toLocaleTimeString("es-MX", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });

      return hora24;
    },
    onEventCreate(event, deleteEventFunction) {
      this.selectedEvent = event;
      this.selectedEvent.title = "TRABAJO";
      this.deleteEventFunction = deleteEventFunction;
      this.showEventCreationDialog = true;
      return event;
    },
    onEventResize(event) {
      const index = this.events.findIndex((e) => e.id === event.id);
      if (index > -1) {
        this.events.splice(index, 1, { ...event });
      }
    },
    prepareDelete(event) {
      this.eventToDelete = event;
      this.showDeleteDialog = true;
    },
    confirmDelete() {
      const index = this.events.findIndex(
        (e) => e.id === this.eventToDelete.id
      );
      if (index > -1) {
        this.events.splice(index, 1);
      }
      this.showDeleteDialog = false;
      this.eventToDelete = null;
    },
    cancelEventCreation() {
      this.deleteEventFunction();
      this.showEventCreationDialog = false;
    },

    closeCreationDialog() {
      this.selectedEvent.class =
        this.selectedEvent.title === "TRABAJO" ? "trabajo" : "descanso";

      if (!this.selectedEvent.id) {
        this.selectedEvent.id = Date.now().toString();
      }

      this.events.push({ ...this.selectedEvent });
      this.showEventCreationDialog = false;
    },
  },
};
</script>

<style>
.vuecal__now-line {
  display: none;
}
.trabajo {
  border: 1px solid #2e5a88;
  background-color: #c0e6f0;
}
.descanso {
  border: 1px solid #a57a2a;
  background-color: #f5e6ca;
}
.event-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  padding: 4px 6px;
}
</style>
